// extracted by mini-css-extract-plugin
module.exports = {"flop":"FlopGameSecond_flop__SaLDH"};